import dayjs from 'dayjs';
import { isMobileOnly } from 'react-device-detect';
import { isA1App } from '../platform/platformDetection';

/**
 * [判断设备] 千万要保留。很多看版用，device_type in properties
 */
export const getDevice = () => {
	return isMobileOnly ? (isA1App ? 'APP' : 'MOBILE') : 'PC';
};
// 判断操作系统
export function detectOS() {
	const userAgent = navigator.userAgent;
	let result = '';

	// 检测移动设备
	const isWindowsPhone = /Windows Phone/i.test(userAgent);
	const isAndroid = /Android/i.test(userAgent);
	const isiOS = /iPhone|iPad|iPod/i.test(userAgent);

	// 检测桌面操作系统
	const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/i.test(userAgent);
	const isLinux = /Linux/i.test(userAgent) && !/Android/i.test(userAgent);
	const isWindows = /Windows NT/i.test(userAgent);

	if (isWindowsPhone) {
		result = 'Windows Phone';
	} else if (isAndroid) {
		result = 'Android';
	} else if (isiOS) {
		result = 'iOS';
	} else if (isMac) {
		result = 'Mac';
	} else if (isLinux) {
		result = 'Linux';
	} else if (isWindows) {
		// 更详细的Windows版本检测
		if (/Windows NT 10.0/.test(userAgent)) {
			result = 'Windows 10';
		} else if (/Windows NT 6.3/.test(userAgent)) {
			result = 'Windows 8.1';
		} else if (/Windows NT 6.2/.test(userAgent)) {
			result = 'Windows 8';
		} else if (/Windows NT 6.1/.test(userAgent)) {
			result = 'Windows 7';
		} else if (/Windows NT 6.0/.test(userAgent)) {
			result = 'Windows Vista';
		} else if (/Windows NT 5.2/.test(userAgent)) {
			result = 'Windows Server 2003';
		} else if (/Windows NT 5.1/.test(userAgent)) {
			result = 'Windows XP';
		} else if (/Windows NT 5.0/.test(userAgent)) {
			result = 'Windows 2000';
		} else {
			result = 'Windows';
		}
	} else {
		result = 'other';
	}

	return result;
}

/**
 * 获取当前时间，以东八区时间表示
 *
 * 【注意】只在特定场景使用：埋点上报
 * @returns {string} 格式化后的时间
 */
export function getUTC8TimeString() {
	const formattedTime = dayjs().tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss');
	return formattedTime;
}
